module.exports = __webpack_public_path__ + "static/media/feature-cross.c5e95a0e.png";